import { useForm } from "react-hook-form";
import styled from "styled-components";
import SanitizeInputFunction from "../../../../Functions/SanitizeInputFunction";
import { useContext, useState } from "react";
import GreenCheck from "./img/green-check.png"
import RedCheck from "./img/red-check.png"
import NameIcon from "./img/account_circle.png"
import PasswordIcon from "./img/key.png"
import SanitizePasswordFunction from "../../../../Functions/SanitizePasswordFunction";
import { PageContext } from "../../../../Context/PageContext";
import PopUpWarning, { PopUpCaller } from "../../../../PopUpWarning/PopUpWarning";
import EmailConfirmFormulary, { GenerateValidationCodeFunction } from "../../../../EmailConfirmFormulary/EmailConfirmFormulary";
import { ApiConnectLionsUserChangePassword, ApiConnectLogRegister } from "../../../../api/LionsUserApiConect";
import SolicitarVip from "../SolicitarVip";
import OperationSucess from "./OperationSucess";
import PopUpImg from "../img/wallpaper_60_1024.png"
import UserNotLogged from "../UserNotLogged";

function ChangeLionsUserPassword() {

    const {register, getValues} = useForm();
    const { user, setPopMenuContent, setDashboardPageSelection, setPage, setIsLogged} = useContext(PageContext)

    const [loginAvaliableCheck, setLoginAvaliableCheck] = useState();
    const [visiblePassword, setVisiblePassword] = useState("password");
    const [validPasswordIcon, setValidPasswordIcon] = useState("");
    const [validConfirmPasswordIcon, setValidConfirmPasswordIcon] = useState("");
    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");

    const [availableSubmit, setAvailableSubmit] = useState("none");
    



    function checkLoginField () {

        let sanitizedLogin = getValues('userName');

        if(sanitizedLogin.length == 0) {
            setLoginAvaliableCheck("");
            return false; }

        if(sanitizedLogin.length < 4) {
            setLoginAvaliableCheck(RedCheck); 
            return false;
        }  
        
         if(sanitizedLogin != user.userName) {
            setLoginAvaliableCheck(RedCheck); 
            return false;
        }
        
        setLoginAvaliableCheck(GreenCheck); 
            return true;
    
    }

    function checkPasswordField () {
    
            var passContentField = getValues('userPassword');
    
            if(passContentField.length === 0 ) {
                setValidPasswordIcon("")
                return false;
            }

            if(passContentField.length < 4 && passContentField.length > 0 ) {
                setValidPasswordIcon(RedCheck);
                return false;
            }
    
            const regexMaiuscula = /["A-Z"]/;
            const regexMinuscula = /[a-z]/;
            const regexNumero = /[0-9]/;
            const regexCaractereEspecial = /[!@#$&*]/;
            
            const temMaiuscula = regexMaiuscula.test(passContentField);
            const temMinuscula = regexMinuscula.test(passContentField);
            const temNumero = regexNumero.test(passContentField);
            const temCaractereEspecial = regexCaractereEspecial.test(passContentField);
    
            if(temMaiuscula === false || temMinuscula === false || temNumero === false || temCaractereEspecial === false) {
                setValidPasswordIcon(RedCheck)
                return false;
            };
    
            setValidPasswordIcon(GreenCheck)
            return true;
        }
    
    
        function confirmationPassword () {

            let passConfirmation = getValues('pass_confirmation');
    
            if(passConfirmation.length === 0) {
                setValidConfirmPasswordIcon("");
                return false;
            }
    
            if(getValues('userPassword') !== passConfirmation || passConfirmation.length < 4) {
                setValidConfirmPasswordIcon(RedCheck);
                return false;
            }
            setValidConfirmPasswordIcon(GreenCheck);
            return true;
        }

    function fieldsValidation(){

        if(checkLoginField() === false  || checkPasswordField() === false || confirmationPassword() === false ) {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;

        } else { 
            setSubmitButtonColor("rgb(11, 85, 158)");
            setAvailableSubmit("auto");}

        return;
        }

        async function submitDataAndUpdateAccess() {

            var negado = "Atualização Negada! Houve algum problema com os dados inseridos. Tente novamente."

            let newPassUser = user;
            newPassUser.userPassword = getValues('userPassword');

            let result = ApiConnectLionsUserChangePassword(newPassUser);
                result.then((response) => {

                    if(response.status == 403 || response.status == 401) {
                        setPage(<UserNotLogged />);
                        setIsLogged(false);
                        return;
                    }

                    if(response.data === false) {
                        PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000)
                    } else { 
                        ApiConnectLogRegister(user, `Mudou a senha da Conta principal em: `);
                        setPopMenuContent(<OperationSucess />);
                    }
            })
        }



    return(
        <MasterContainer>
        <NewAcessoContainer >
            <TitleContainer>
                <h1>ALTERAR SENHA DA CONTA</h1>
                <span>Preencha os campos abaixo para solicitar a alteração da senha do sua conta:<br/></span>
                <h3>{user.userName}</h3>
            </TitleContainer>

            <PopUpWarning />

                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={NameIcon}/>
                            <ColumItemHeaderName>Login</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={loginAvaliableCheck}/>
                        </FieldDescriptionContainer>
                        <Input
                            type="text"
                            size="30" 
                            pattern=".{4,23}"
                            {...register("userName", {
                                onChange: (e) => {
                                    var sanitizedInput = SanitizeInputFunction(e.target.value);
                                    e.target.value = sanitizedInput;
                                    fieldsValidation();}
                                    })}
                            required 
                            placeholder=" minimo 4 digitos"
                            />
                    </AcessoItemContainer>


                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                            <ColumItemHeaderName>Nova Senha</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={validPasswordIcon}/>
                        </FieldDescriptionContainer>
                        <Input
                            type={visiblePassword}
                            size="32"
                            {...register("userPassword", {
                                onChange: (e) => {
                                    var sanitizedPass = SanitizePasswordFunction(e.target.value);
                                    e.target.value = sanitizedPass;
                                    fieldsValidation();}
                            })}
                            pattern=".{6,32}"
                            placeholder=" Mínimo de 6 digitos"
                            required />
                    </AcessoItemContainer>

                    <AcessoItemContainer>
                        <FieldDescriptionContainer>
                            <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                            <ColumItemHeaderName>Confirme</ColumItemHeaderName>
                            <FieldAvaliableCheck checkImg={validConfirmPasswordIcon}/>
                        </FieldDescriptionContainer>
                                                    
                        <Input
                        type={visiblePassword}
                        size="32"
                        pattern=".{6,32}"
                        placeholder="Confirme a Senha"
                        {...register('pass_confirmation', {
                            onChange: (event) =>{
                                event.target.value = SanitizePasswordFunction(event.target.value);
                                fieldsValidation(); }
                            })
                        }
                        required
                        />
                    </AcessoItemContainer>


                    <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {

                        GenerateValidationCodeFunction(getValues('userName'), user.userEmail, "codeToEmail");
                        setPopMenuContent(
                        <EmailConfirmFormulary
                            ActionFunction={submitDataAndUpdateAccess}
                            userMail={user.userEmail}>
                        </EmailConfirmFormulary>
                        )
                    }
                    }
                    value="Alterar Senha"
                    available={availableSubmit}
                    />
        </NewAcessoContainer>

        <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>
    )
}

export default ChangeLionsUserPassword;

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`

const NewAcessoContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    width: 500px;
    margin: 5px 0;
    transition: .3s ease-in-out;
    //color: white;
    //border: solid 1px;
    //box-shadow: 10px 10px 10px 0px black;

    &:hover {
    transform: translate(0px, 0px);
    //background-color: rgba(65, 102, 137, 0.8);
    //color: white;

    }

`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
`

const AcessoItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    //border: solid 2px black;
    width: 420px;
    font-size: 18px;
    text-align: center;
    //border: solid;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const FieldDescriptionContainer = styled.div`
    display: flex;
    align-items: center;

`


const Input = styled.input`
    height: 30px;
    width: 200px;
    margin: 10px 0;
    border-radius: 0px;
    border: solid 0px rgba(0,0,0,.5);
    border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 16px;

`


const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;
`

const ColumItemHeaderName = styled.span`
    font-weight: bold;
`

const FieldAvaliableCheck = styled.div`
    background-image: url(${props => props.checkImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 20px;
    height: 20px;
    margin-left: 20px;
    margin-right: 20px;
`

const ConfirmInput = styled.input`
    height: 50px;
    padding: 0px 5px;
    width: 200px;
    margin: 30px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    
    }
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 500px;
    height: 560px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }

`
